import { campaignDisplayPriority } from 'loyalty/constants/loyaltyBonusPoints'
import { triplePointCampaignId } from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeoverConfig'
import { SOCIETE_DOUBLE_POINTS_TAKEOVER_ID } from 'takeovers/societeDoublePointsTakeover/constants/societeDoublePointsTakeoverConstants'

export function getLoyaltyBonusPointsCampaignTypes({ bonusPoints, basePoints, bonusStatusCredits, statusCredits }: {
  basePoints: number
  bonusPoints: number
  bonusStatusCredits: number
  statusCredits: number
}): Array<App.LoyaltyBonusPointsCampaignType> {
  const campaigns: Array<App.LoyaltyBonusPointsCampaignType> = []

  // Check for double status credits campaign
  const hasStatusCreditsBonus = bonusStatusCredits && statusCredits && bonusStatusCredits / statusCredits === 1
  if (hasStatusCreditsBonus) {
    campaigns.push('double_status_credits')
  }

  // Check for points-based campaigns
  if (bonusPoints && bonusPoints > 0) {
    const ratio = bonusPoints / basePoints
    switch (ratio) {
      case 1:
        campaigns.push('double')
        break
      case 2:
        campaigns.push('triple')
        break
      default:
        if (ratio > 0) {
          campaigns.push('static')
        }
        break
    }
  }

  return campaigns
}

export function isBonusPointsCampaignType(campaignType: App.LoyaltyBonusPointsCampaignType): boolean {
  return campaignType === 'triple' || campaignType === 'double' || campaignType === 'static'
}

export function getHighestBonusPointsCampaignType(
  campaignTypes: Array<App.LoyaltyBonusPointsCampaignType>,
): App.LoyaltyBonusPointsCampaignType | undefined {
  return campaignTypes.reduce<App.LoyaltyBonusPointsCampaignType | undefined>((highestCampaignType, campaignType) => {
    if (!highestCampaignType) return campaignType

    return campaignDisplayPriority[campaignType] > campaignDisplayPriority[highestCampaignType] ?
      campaignType :
      highestCampaignType
  }, undefined)
}

export function isStatusCreditsCampaignType(campaignType: App.LoyaltyBonusPointsCampaignType): boolean {
  return campaignType === 'double_status_credits'
}

export function determineOfferLoyaltyBonusPointsCampaignType(
  offer:
    | App.Offer
    | App.OfferSummary
    | App.HotelOffer
    | App.HotelOfferSummary
    | App.BedbankOffer
    | App.BedbankOfferSummary
    | App.Tours.TourV2Offer
    | App.Tours.TourV2OfferSummary
    | App.CruiseOffer
    | App.ExperienceOffer,
): App.LoyaltyBonusPointsCampaignType | undefined {
  if (offer.campaignTags.includes(triplePointCampaignId)) return 'triple'
  if (offer.campaignTags.includes(SOCIETE_DOUBLE_POINTS_TAKEOVER_ID)) return 'double_status_credits'
}

function determineLoyaltyBonusPointsCampaignType(calculation: Omit<App.LoyaltyPointsEarnCalculation, 'request'>): Array<App.LoyaltyBonusPointsCampaignType>
function determineLoyaltyBonusPointsCampaignType(calculation: App.LoyaltyPointsEarnCalculation): Array<App.LoyaltyBonusPointsCampaignType> {
  return getLoyaltyBonusPointsCampaignTypes({
    basePoints: calculation.basePoints,
    bonusPoints: calculation.bonusPoints,
    bonusStatusCredits: calculation.bonusStatusCredits,
    statusCredits: calculation.statusCredits,
  })
}

export default determineLoyaltyBonusPointsCampaignType
